/*
 * @Description:每个模块的配置
 * @Autor: Sia
 * @Date: 2019-11-06 11:40:31
 * @LastEditors  : Sia
 * @LastEditTime : 2020-01-13 18:15:34
 */
import { performanceHeader, performanceContent } from "./configs/performance";
import { operateHeader, operateContent } from "./configs/operate";
import { marketHeader, marketContent } from "./configs/market";
import { queryHeader, queryContent } from "./configs/query";

const headerConfig = [
  ...operateHeader,
  ...performanceHeader,
  ...marketHeader,
  ...queryHeader
];
const contentConfig = [
  ...operateContent,
  ...performanceContent,
  ...marketContent,
  ...queryContent
];
let getConfig = name => {
  let a = {};
  contentConfig.forEach(item => {
    if (item.name === name) {
      a = item.value;
    }
  });
  return a;
};
let getHeaderConfig = name => {
  let b = {};
  headerConfig.forEach(item => {
    if (item.name === name) {
      b = item;
    }
  });
  return b;
};
export { getConfig, getHeaderConfig };
